import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { getWindow } from '@ps/web-core-utils';
import { useDispatch, useSelector } from 'react-redux';

import { type Dispatch, select } from '@swf/core/store';

const bonusCash = {
  c2l: 'awardstatus/SportsCashBonus',
  path: '/account/my-stars/bonus/sports-bonus-cash'
};
const freeBets = {
  c2l: 'awardstatus/FreeBets',
  path: '/account/my-stars/bonus/free-bets'
};

export default (isBonusCash: boolean) => {
  const { modal } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isPRHubEnabled = useFeature(FeatureFlag.PRHub);

  const { c2l, path } = isBonusCash ? bonusCash : freeBets;

  return {
    action: () => {
      if (isEmbedded && isPRHubEnabled) {
        getWindow()?.starsweb?.app.execute(c2l);
      } else {
        modal.enqueue({ path });
      }
    },
    path
  };
};
